// OfflineBanner — slim top banner that appears when the user goes offline
// and briefly confirms when they reconnect.
//
// Mounts once globally inside <App>. Renders nothing on desktop, nothing while
// online (other than the brief "reconnected" confirmation).

import { useNetworkStatus } from '@/hooks/useNetworkStatus'

export default function OfflineBanner() {
  const { isOffline, justReconnected } = useNetworkStatus()

  if (!isOffline && !justReconnected) return null

  if (justReconnected) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="fixed top-0 left-0 right-0 z-[55] safe-top md:hidden bg-emerald-50 text-emerald-900 text-xs font-medium px-4 py-1.5 text-center border-b border-emerald-200 animate-[fadeIn_0.2s_ease-out]"
      >
        Conectat. Sincronizăm datele…
      </div>
    )
  }

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[55] safe-top md:hidden bg-amber-50 text-amber-900 text-xs font-medium px-4 py-1.5 text-center border-b border-amber-200"
    >
      Modul offline — anumite funcții sunt indisponibile
    </div>
  )
}
